import { useState } from 'react';
import { BatchFileLogClient, BatchFileLogDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useBatchFileLogApi = () => {
    const apiClient = new BatchFileLogClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: BatchFileLogDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createBatchFileLog(data);
        } catch (err: any) {
            setError(err.message || 'Error creating BatchFileLog');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: BatchFileLogDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateBatchFileLog(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating BatchFileLog');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getBatchFileLogById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching BatchFileLog');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchBatchFileLogs(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching BatchFileLogs');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteBatchFileLog(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting BatchFileLog');
        } finally {
            setIsLoading(false);
        }
    };

    const checkBatchFile = async (batchNumber: string) => {
        setIsLoading(true);
        try {
            const response = await apiClient.checkBatchFile(batchNumber);
            return response;
        } catch (err: any) {
            setError(err.message || 'Error checking batch file status');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { 
        create, 
        edit, 
        getById, 
        search, 
        remove, 
        checkBatchFile, 
        isLoading, 
        error 
    };
};